module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/221-tuvalu-3a987d1a85557158d74e9e667a0aadcc.svg";